import { LOCALES, USER_ROLES } from '@plancia/contracts';
import { z } from 'zod';

// Response bodies of the internal API the console reads, mirrored from the
// API DTOs (apps/api/src/modules/*/dto.ts). Unknown keys pass through.

export const userSchema = z.looseObject({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  role: z.enum(USER_ROLES),
  locale: z.enum(LOCALES).catch('it'),
  active: z.boolean(),
  totp_enabled: z.boolean(),
  last_login_at: z.string().nullable(),
  /** An invitation's temporary password still in use: «Scegli una nuova password» first (ADR 0059). */
  must_change_password: z.boolean().optional(),
  /** An owner without TOTP on a host that requires it: «Attiva la verifica in due passaggi» first (ADR 0067). */
  totp_setup_required: z.boolean().optional(),
});
export type User = z.infer<typeof userSchema>;

export const loginResponseSchema = z.looseObject({ user: userSchema, expires_at: z.string() });

export const readyzSchema = z.looseObject({
  status: z.string(),
  checks: z.record(z.string(), z.string()).optional(),
});

export const extensionClientSchema = z.looseObject({
  client_name: z.string(),
  version: z.string().nullable(),
  last_seen_at: z.string().nullable(),
  state: z.string(),
  current_job_id: z.string().nullable(),
  paused: z.boolean(),
  outdated: z.boolean(),
});
export const extensionClientsSchema = z.looseObject({ items: z.array(extensionClientSchema) });
export type ExtensionClient = z.infer<typeof extensionClientSchema>;

export const budgetSchema = z.looseObject({
  spent_usd: z.number(),
  cap_usd: z.number(),
  by_model: z.record(z.string(), z.number()),
});
export type Budget = z.infer<typeof budgetSchema>;

export const listSchema = z.looseObject({ items: z.array(z.unknown()) });
